var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function (selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " + extraClasses + "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function () {
		site.owl.init('#owl-testimonial', {
			'items': 1,
			'nav': true,
			'navText': ["", ""],
			'loop': true,
			'autoplay': false
		});

	}
};

site.coursesMixitup = {
	init: function () {
		var targetSelector = '.course';

		/**
		 * Reads a hash from the URL (if present), and converts it into a class
		 * selector string. E.g "#green" -> ".green". Otherwise, defaults
		 * to the targetSelector, equivalent to "all"
		 *
		 * @return {string}
		 */
		function getSelectorFromHash() {
			var hash = window.location.hash.replace(/^#/g, '');

			var selector = hash ? '.' + hash : targetSelector;

			return selector;
		}

		/**
		 * Updates the URL whenever the current filter changes.
		 *
		 * @param   {mixitup.State} state
		 * @return  {void}
		 */
		function setHash(state) {
			var selector = state.activeFilter.selector;
			var newHash = '#' + selector.replace(/^./g, '');

			if (selector === targetSelector && window.location.hash) {
				// Equivalent to filter "all", remove the hash

				history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
			} else if (newHash !== window.location.hash && selector !== targetSelector) {
				// Change the hash

				history.pushState(null, document.title, window.location.pathname + newHash); // or history.replaceState()
			}
		}

		// Instantiate and configure the mixer
		var mixer = mixitup('.coursesContainer', {
			selectors: {
				target: targetSelector
			},
			animation: {
				enable: false
			},
			load: {
				filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
			},
			callbacks: {
				onMixEnd: setHash // Call the setHash() method at the end of each operation
			}
		});

		window.onhashchange = function () {
			var selector = getSelectorFromHash();
			if (selector === mixer.getState().activeFilter.selector) return; // no change

			mixer.filter(selector);
		};
	}
};

site.courseColor= {
	init: function () {
		var $classes = $('body').attr('class').split(' ');
		for (var i = 0; i < $classes.length; i++) {
			if ($classes[i].startsWith('color')) {
				var $color = $classes[i].replace('color', '');
				$('#breadcrumbs, .boxTitle h1').css('background-color', $color);
			}
		}
	}
};

// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	$('.timetableToggler').on('click', function (e) {
		e.preventDefault();
		$(this).siblings('.timetable').slideToggle();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.inna') && $('.reviews', '#inna').length) {
		site.owl.init('#inna .reviews', {
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			'items': 1,
			'nav': true,
			autoHeight: true,
			'navText': ["", ""],
			'loop': true,
			'autoplay': false
		});
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	if ($('.coursesContainer').length) {
		site.coursesMixitup.init();
	}

	if ($('.coursesView').length) {
		site.courseColor.init();
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
